import { render, staticRenderFns } from "./QuoteAndDraftBookinDetails.vue?vue&type=template&id=47f3e0d2&scoped=true"
import script from "./QuoteAndDraftBookinDetails.vue?vue&type=script&lang=js"
export * from "./QuoteAndDraftBookinDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f3e0d2",
  null
  
)

export default component.exports